module.exports = __webpack_public_path__ + "static/media/productseperator.94ffec8c.png";